import { render, staticRenderFns } from "./SavingsContent.vue?vue&type=template&id=f40233de"
import script from "./SavingsContent.vue?vue&type=script&lang=js"
export * from "./SavingsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports